import { ISettingResponse } from "@/domain/setting.interface";
import { settingService } from "../../services/setting.service";
import { useQuery } from "@tanstack/react-query";

const { findAll } = settingService;

export const useGetSetting = () => {
	const settingsQuery = useQuery({
		queryKey: ["get-setting-list"],
		queryFn: findAll,
		staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
	});

	return settingsQuery;
};

export const useCurrencySetting = (): ISettingResponse => {
	const { data } = useSettings();
	const currencySetting = data?.currency;
	return currencySetting as unknown as ISettingResponse;
};

export const useIANATimeZoneSetting = (): string => {
	const { data } = useGetSetting();
	const timeZoneSetting = data?.find(
		(setting) => setting.name === "IANATimeZone",
	);

	return (timeZoneSetting?.default as string) || "America/New_York";
};

export const useSettingsV2 = (userId?: string) => {
	const accountId = process.env.REACT_APP_ACCOUNT_ID ?? "";
	const settingsQuery = useQuery({
		queryKey: ["get-setting-v2-", accountId, userId],
		queryFn: () => settingService.getSettingsV2(accountId, userId),
		staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
	});

	return settingsQuery;
};

export const useSettings = (userId?: string) => {
	const accountId = process.env.REACT_APP_ACCOUNT_ID ?? "";
	const settingsQuery = useQuery({
		queryKey: ["get-setting-nest-", accountId, userId],
		queryFn: () => settingService.getSettings(),
		staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
		retry: 3,
		retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
	});

	return settingsQuery;
};
